export const addAssociateId = (text) => {
  if (!text || text.includes('tag=') || !text.includes('amazon.com')) return text;
  return text + `&tag=${process.env.REACT_APP_ASSOCIATE_ID}`
}

export const isAssociateLink = (text) => {
  return text && text.includes('tag=') && text.includes('amazon.com')
}